import React, { forwardRef, Ref } from 'react';
import { SimpleIconProps } from '../icon.types';
import Icon from './Icon';

const svg = `<svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none">
  <path d="M8 6L12 2L16 6"/>
  <path d="M12 2V22"/>
</svg>`;

const Arrow = forwardRef(
  (props: SimpleIconProps, ref: Ref<SVGSVGElement> | undefined) => (
    <Icon ref={ref} name='arrow' svg={svg} {...props} />
  )
);

Arrow.displayName = 'ArrowIcon';

export default Arrow;
